import Swiper from 'swiper'
import { Navigation, Pagination, Scrollbar } from 'swiper/modules'
import { GWLitElement } from 'lib/lit-element'
import { html, css } from 'vendor/lit'
import { lowPriority } from 'lib/performance'
import { debounce } from 'utils/general'
import styles from 'styles/mixins'

class HHProductThumbnail extends GWLitElement {
  static properties = {
    active: {
      reflect: true,
    },
  }

  constructor() {
    super()
    this.isPaused = false
    this.galleryMobileEl = this.querySelector('.gallery-mobile')
    this.galleryMobileSwiper = null
    this.desktopMQ = window.matchMedia('(min-width: 750px)')
    this.modalParent = this.closest('stl-dialog');
    console.log('modalParent', this.modalParent)

    this.debouncedDispatchChangeEvent = debounce(this.dispatchChangeEvent.bind(this), 200)
  }

  initSlider() {
    if (!this.galleryMobileEl) return false
    this.galleryMobileSwiper?.destroy()

    this.galleryMobileSwiper = new Swiper(this.galleryMobileEl, {
      modules: [Navigation, Pagination, Scrollbar],
      spaceBetween: 10,
      slidesPerView: 1.3,
      centeredSlides: !this.modalParent,
      loop: true,
      navigation: false,
      pagination: this.modalParent ? false : {
        el: '.swiper-pagination',
        clickable: true,
      },
      scrollbar: this.modalParent ? {
        el: '.swiper-pagination',
        draggable: true,
      } : false,
      breakpoints: {
        750: {
          slidesPerView: 1,
        },
      },
    })

    this.galleryMobileSwiper.on('slideChange', this.debouncedDispatchChangeEvent)
  }

  dispatchChangeEvent() {
    document.dispatchEvent(new CustomEvent('gallery:change'))
  }

  connectedCallback() {
    this.querySelectorAll('.thumb-item').forEach(element => {
      element.addEventListener('mouseenter', e => this.changeMedia(e))
    })

    this.initSlider()
    this.loadImagesOnIdle()

    this.modalParent?.addEventListener('dialog:open', this.initSlider.bind(this))
    this.modalParent?.addEventListener('shop-the-look:modal-update', this.initSlider.bind(this))

    super.connectedCallback()
  }

  disconnectedCallback() {
    this.modalParent?.removeEventListener('dialog:open', this.initSlider.bind(this))
    this.modalParent?.removeEventListener('shop-the-look:modal-update', this.initSlider.bind(this))
    
    super.disconnectedCallback()
  }

  changeMedia(e) {
    const activeMediaId = e.target.getAttribute('media-id')
    this.querySelectorAll('.main-item').forEach(element => {
      if (element.getAttribute('media-id') === activeMediaId) {
        element.classList.add('is-active')
      } else {
        element.classList.remove('is-active')
      }
    })

    this.querySelectorAll('.thumb-item').forEach(element => {
      if (element.getAttribute('media-id') === activeMediaId) {
        element.classList.add('is-active')
      } else {
        element.classList.remove('is-active')
      }
    })

    this.debouncedDispatchChangeEvent()
  }

  loadImages() {
    const images = [
      ...(this.desktopMQ.matches && !this.modalParent
        ? this.querySelectorAll('.main-item img')
        : this.galleryMobileEl.querySelectorAll('img')),
    ]
    for (const image of images) {
      image.setAttribute('loading', 'eager')
    }
  }

  loadImagesOnIdle() {
    lowPriority(this.loadImages.bind(this), 2)
  }

  // render() {
  //   return html`
  //     <slot name="gallery-mobile"></slot>
  //     <slot name="gallery-thumbnails"></slot>
  //     <div class="product-thumbnails__main">
  //       <slot name="sale-badge"></slot>
  //       <slot name="main-item"></slot>
  //     </div>
  //   `
  // }

  render() {
    return html`
      <slot name="gallery-mobile"></slot>
      ${this.modalParent ? html`` : html`
        <div class="product-thumbnails__thumb">
          <slot name="thumb-item"></slot>
        </div>
        <div class="product-thumbnails__main" style="width: 100%; position: relative;">
          <slot name="sale-badge"></slot>
          <slot name="main-item"></slot>
        </div>
      `}
    `
  }

  static styles = [
    styles.visuallyHidden,
    css`
      :host {
        display: flex;
      }

      .product-thumbnails__thumb {
        width: 75px;
      }

      .product-thumbnails__main {
        width: 100%;
        position: relative;
      }

      @media screen and (max-width: 749.9px) {
        :host {
          aspect-ratio: var(--hh-aspect-ratio);
          max-height: var(--hh-max-height);
          flex-direction: column-reverse;
          gap: 10px;
        }

        .product-thumbnails__main,
        .product-thumbnails__thumb {
          display: none;
        }
      }
    `,
  ]
}

customElements.define('hh-product-thumbnails', HHProductThumbnail)
